module.exports = __webpack_public_path__ + "static/img/home_broadcast@3x.dc6cb1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_broadcast@3x.png
// module id = OBs+
// module chunks = 1